module.exports = __webpack_public_path__ + "img/icon_map_gwsh.4daed14a.png";